import { useKeycloak } from '@react-keycloak/web';
import React, { useState } from 'react';
import {Form, Col, Button} from 'react-bootstrap';
import {useFormik} from 'formik';
import * as yup from 'yup';
import download_icon from '../../assets/img/download.png';
import '../../styles/css/ReportPanel.css';
import micro_reporter_api from "../../apis/micro-reporter-api";

const DownloadForm = (props) => {

    const [isActive, setActive] = useState(false);
    const { keycloak } = useKeycloak();


  const formik = useFormik({
        initialValues: {
            reportName: "",
            count: "300000",
            type: "excel",
        },
        validationSchema: yup.object({
            reportName: yup.string().required('Report name can not be blank.'),
            count: yup.number().required('Count can not be blank.').max(300000).min(1),
        }),
        onSubmit: values => {
            if (document.getElementById('csv-radio').checked) {
                values.type = "csv";
            }else{
                values.type = "excel";
            }
            downloadData(values.reportName, values.count, values.type);
          },
    });

    const downloadData = async (fileName, maxFileRowCount, fileType) => {
        let ipAddress = micro_reporter_api.defaults.proxy;
        let blobUrl = ipAddress+'/micro-reporter/report/download-' + fileType;
        let user = JSON.parse(localStorage.getItem("user"));
        let headers = {"userId": user.id, "username": user.username, "relatedName": encodeURIComponent(props.reportName), "relatedId": props.model.rid, "maxFileRowCount": maxFileRowCount, "paramFileName": encodeURIComponent(fileName), "rid": props.model.rid};

        const config = {method:"POST", headers: headers, responseType: 'blob'};

        setActive(true);

        await (async () => {
            await micro_reporter_api.post('/micro-reporter/report/download-' + fileType, {}, config).then(
                (response) => {
                    if (response.status === 200) {
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = fileName + '.zip';
                        a.click();
                    }
                    setActive(false);
                }
            )
        })();
    }

    return(
        <div className="container">
            <div>
                <div id="report-center-div">
                <Form noValidate onSubmit={formik.handleSubmit} id="download-form">
                    <Form.Row>
                        <Form.Group as={Col} md="12" controlId="validationFormik01">
                            <Form.Label>Report Name</Form.Label>
                            <Form.Control
                            type="text"
                            name="reportName"
                            placeholder=""
                            onChange={formik.handleChange}
                            value={formik.values.reportName}
                            onBlur={formik.handleBlur}
                            />
                            {formik.touched.reportName && formik.errors.reportName ? (
                                <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.reportName}</div>
                            ) : null}
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="12" controlId="validationFormik06">
                            <Form.Label>Row Count</Form.Label>
                            <span style={{fontSize:"10px", marginLeft: "5px"}}>(max: 300.000)</span>
                            <Form.Control
                            type="number"
                            name="count"
                            onChange={formik.handleChange}
                            value={formik.values.count}
                            onBlur={formik.handleBlur}
                            />
                            {formik.touched.count && formik.errors.count ? (
                                <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.count}</div>
                            ) : null}
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                    <Form.Group id="formGridCheckbox" style={{paddingLeft: "5px"}}>
                        <Form.Label>File Type</Form.Label>
                        <div key="custom-inline-radio" className="mb-3">
                            <Form.Check
                                custom
                                inline
                                defaultChecked
                                name="fileType"
                                label="excel"
                                type="radio"
                                id="excel-radio"
                            />
                            <Form.Check
                                custom
                                inline
                                name="fileType"
                                label="csv"
                                type="radio"
                                id="csv-radio"
                            />
                        </div>
                    </Form.Group>
                    </Form.Row>
                    <Button type="submit" disabled={isActive} block>
                        <img src={download_icon} alt="download" style={{width:"17px", height:"17px", marginBottom:"4px", marginRight:"5px"}}/>
                        Export
                    </Button>
                </Form>
                </div>
            </div>
        </div>
    );

}

export default DownloadForm;
